import { useQuery, type QueryClient } from "@tanstack/react-query";
import { apiGet } from "@/api/client";

const key = (patientId: string) => ["patient-photo", patientId] as const;

/**
 * The patient's photo URL ("" when none). A photo the caller already has
 * (photoUrl, even "") is used as is; otherwise it is fetched once per
 * patient and cached, so a schedule with many visits asks only once each.
 */
export function usePatientPhoto(patientId?: string | null, photoUrl?: string | null): string {
  const known = photoUrl !== undefined && photoUrl !== null;
  const q = useQuery({
    queryKey: key(patientId ?? ""),
    queryFn: () => apiGet<{ photo_url?: string }>(`/patients/${patientId}/photo`).then((r) => r.photo_url ?? ""),
    enabled: Boolean(patientId) && !known,
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
    retry: false,
    meta: { silent: true },
  });
  return known ? photoUrl ?? "" : q.data ?? "";
}

/** Call after a patient's photo changes so every avatar updates. */
export function setPatientPhotoCache(qc: QueryClient, patientId: string, photoUrl: string) {
  qc.setQueryData(key(patientId), photoUrl);
}
